import React, { memo, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, Row, Col } from 'antd'

import classes from './styles.module.scss'
import { TProfileProps } from 'models'

import {
	RegisterForm,
	HeaderForm,
	ResendQRCode,
	SuccessfullyOperation,
} from './components'

const { TabPane } = Tabs

const SUCCESSFULLY_REGISTER_TXT =
	'Pentru a finaliza procesul de inregistrare, valideaza adresa de e-mail dand click pe linkul din e-mailul primit. Daca nu gasesti e-mailul in Inbox, cauta si in folderele Spam sau Junk. Dupa confirmare vei primi un nou e-mail pe care il vei folosi pentru a intra in posesia Chill Pack-ului.'
const SUCCESSFULLY_RESEND_QR_CODE =
	'Vei primi email-ul cu codul QR de participare la Chill Pack 2022 editia de toamna.'

const ChillPack: React.FunctionComponent<TProfileProps> = () => {
	const [showSuccessfullyOperationPage, setShowSuccessfullyOperationPage] =
		useState(false)
	const [successfullyOperationText, setSuccessfullyOperationText] =
		useState('')

	const handleRegistration = useCallback(() => {
		setShowSuccessfullyOperationPage(true)
		setSuccessfullyOperationText(SUCCESSFULLY_REGISTER_TXT)
	}, [])

	const handleResendQRCode = useCallback(() => {
		setSuccessfullyOperationText(SUCCESSFULLY_RESEND_QR_CODE)
		setShowSuccessfullyOperationPage(true)
	}, [])

	return (
		<>
			{!showSuccessfullyOperationPage ? (
				<Row className={classes.container}>
					<Col xs={22} md={16}>
						<HeaderForm />
						<Tabs
							className={classes.tabName}
							defaultActiveKey="register"
						>
							<TabPane tab={'Inregistreaza-te'} key="register">
								<RegisterForm
									handleRegistration={handleRegistration}
								/>
							</TabPane>
							<TabPane
								tab={'Recupereaza codul'}
								key="recoverCode"
							>
								<ResendQRCode
									handleResendQRCode={handleResendQRCode}
								/>
							</TabPane>
						</Tabs>
					</Col>
				</Row>
			) : (
				<SuccessfullyOperation text={successfullyOperationText} />
			)}
		</>
	)
}

export default memo((props: TProfileProps) => <ChillPack {...props} />)
